export class WidgetProps {
    continueInitialization = true;

    /*without this the class should not be initiated at all*/
    container = null;

    selectors = {};

    elements = {};

    uris = {};

    constructor(container) {
        this.container = container;
    }
}

export default class BaseWidget {
    props;

    constructor(container) {
        this.props = this.getPropsInstance(container);
        this.init();
    }

    init() {}

    setElements() {}

    addListeners() {}

    getPropsInstance(container) {
        return new WidgetProps(container);
    }

    getElementsArray(selector, element = document) {
        return Array.prototype.slice.call(element.querySelectorAll(selector));
    }

    set isLoading(isLoading) {
        if (!isLoading && this.props.elements.loadingOverlay) {
            this.props.elements.loadingOverlay.remove();
            this.props.elements.loadingOverlay = null;
        } else {
            this.addOverlay();
        }
    }

    get overlayContent() {
        return `<div class="loading-overlay" style="display: block;"><div class="loading-container"><div class="loading"></div></div></div>`;
    }

    setError(wrapperItem, error, errorString) {
        if (error) {
            error.textContent = errorString;
        } else {
            wrapperItem.insertAdjacentHTML('beforeend', `<p class="error">${errorString}</p>`);
        }
    }

    addOverlay() {
        document.body.insertAdjacentHTML('beforeend', this.overlayContent);
        this.props.elements.loadingOverlay = document.querySelector('.loading-overlay');
    }
}
